import React from "react";

const Java_Char = () => {
  return (
    <div>
      <h1>Java Char</h1>
      <p>This page provides explanations, examples, and common use-cases for Java Char in Java.</p>
    </div>
  );
};

export default Java_Char;
